import React, { Component } from "react";

class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.create_account_confirmation_line_1 =
      window.create_account &&
      window.create_account.create_account_confirmation_line_1
        ? window.create_account.create_account_confirmation_line_1
        : "";

    this.create_account_confirmation_line_2 =
      window.create_account &&
      window.create_account.create_account_confirmation_line_2
        ? window.create_account.create_account_confirmation_line_2
        : "";
  }

  render() {
    return (
      <div className="create-account__confirmation">
        <div className="create-account__confirmation-icon" aria-hidden="true">
          {/* FA Free 6.x Solid envelope — CC BY 4.0 */}
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
          </svg>
        </div>
        {this.create_account_confirmation_line_1 && (
          <p className="create-account__confirmation-text">
            {this.create_account_confirmation_line_1}
          </p>
        )}
        {this.create_account_confirmation_line_2 && (
          <p className="create-account__confirmation-text">
            {this.create_account_confirmation_line_2}
          </p>
        )}
        <div className="create-account__confirmation-cta">
          <a href="/login" className="create-account__submit">
            Sign In Now
          </a>
        </div>
      </div>
    );
  }
}
export { Confirmation };
